var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3095 3.29321H3.74481C2.94672 3.29321 2.30029 3.97864 2.30029 4.82296V12.4703C2.30029 13.3153 2.94672 14 3.74481 14H11.6897C12.4878 14 13.1342 13.3153 13.1342 12.4703V6.87274L10.3073 9.86578C10.0604 10.1298 9.7389 10.3122 9.38567 10.3887L7.44929 10.7989C6.18533 11.0662 5.07161 9.88673 5.3244 8.5491L5.71153 6.4986C5.78159 6.12881 5.95349 5.78862 6.20555 5.52211L8.3095 3.29321Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4681 1.95125C14.3951 1.76637 14.288 1.59684 14.1524 1.45144C14.0192 1.30925 13.8585 1.1955 13.6801 1.11704C13.5043 1.03985 13.3145 1 13.1225 1C12.9305 1 12.7407 1.03985 12.5649 1.11704C12.3865 1.1955 12.2258 1.30925 12.0926 1.45144L11.6982 1.86891L13.7581 4.05014L14.1524 3.63195C14.2894 3.48766 14.3967 3.31783 14.4681 3.13214C14.6169 2.75257 14.6169 2.33082 14.4681 1.95125ZM12.7375 5.13136L10.6769 2.94941L7.22669 6.60405C7.17578 6.65829 7.14145 6.72595 7.12774 6.79906L6.74061 8.85028C6.69005 9.11751 6.91323 9.35297 7.1653 9.29952L9.1024 8.89C9.17288 8.87429 9.23703 8.83781 9.28658 8.78527L12.7375 5.13136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/Edit_white.94ebd8b5ae75cdc40f68e49c577836e7.svg";
export { ForwardRef as ReactComponent };